import React from "react";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		display: "flex",
		alignItems: "center",
	},
	name: {},
	icon: {
		marginLeft: "8px",
		lineHeight: 1,
	},
	itemImage: {
		width: "22px",
		height: "22px",
		fill: theme.palette.colors.purplishBlue,
	},
});

const SelectFieldItemSort = ({ classes, name, up, down }) => (
	<div className={classes.root}>
		<span className={classes.name}>{name}</span>
		<span className={classes.icon}>
			{!!up && (
				<svg
					className={classes.itemImage}
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					viewBox="0 0 24 24"
				>
					<path
						fill="#5813FE"
						fillRule="evenodd"
						d="M13.2490478,15.7069812 C13.0531811,15.5115234 12.95575,15.2556148 12.95575,14.9997061 C12.95575,14.7437975 13.0531811,14.4878888 13.2490478,14.2934386 C13.6387724,13.902523 14.272577,13.902523 14.6623015,14.2934386 L16.994622,16.6248268 L16.994622,3.95814617 C16.994622,3.40602829 17.403431,3 17.9558756,3 C18.5083201,3 18.9563024,3.44733638 18.9563024,4.00046178 L18.9563024,16.5855338 L21.2484452,14.2934386 C21.6391742,13.902523 22.2729787,13.902523 22.6627033,14.2934386 C23.0534322,14.6833466 23.0534322,15.3160657 22.6627033,15.7069812 L18.664009,19.7058058 C18.5716001,19.7984971 18.4601068,19.8720457 18.3375645,19.9224214 C18.2150223,19.9738046 18.0854489,20 17.9548711,20 C17.6013066,20 17.3210665,19.8539104 17.1543287,19.6131145 L13.2490478,15.7069812 Z M2,15 C2,14.4477153 2.4463114,14 2.99754465,14 L10.0024554,14 C10.553384,14 11,14.4438648 11,15 C11,15.5522847 10.5536886,16 10.0024554,16 L2.99754465,16 C2.44661595,16 2,15.5561352 2,15 Z M2,11 C2,10.4477153 2.45097518,10 2.99077797,10 L7.00922203,10 C7.55641359,10 8,10.4438648 8,11 C8,11.5522847 7.54902482,12 7.00922203,12 L2.99077797,12 C2.44358641,12 2,11.5561352 2,11 Z M2,7 C2,6.44771525 2.45377482,6 2.99820275,6 L4.95754725,6 C5.5088394,6 5.95575,6.44386482 5.95575,7 C5.95575,7.55228475 5.50197518,8 4.95754725,8 L2.99820275,8 C2.4469106,8 2,7.55613518 2,7 Z"
					/>
				</svg>
			)}
			{!!down && (
				<svg
					className={classes.itemImage}
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					viewBox="0 0 24 24"
				>
					<path
						fill="#5813FE"
						fillRule="evenodd"
						d="M13.2490478,15.7069812 C13.0531811,15.5115234 12.95575,15.2556148 12.95575,14.9997061 C12.95575,14.7437975 13.0531811,14.4878888 13.2490478,14.2934386 C13.6387724,13.902523 14.272577,13.902523 14.6623015,14.2934386 L16.994622,16.6248268 L16.994622,3.95814617 C16.994622,3.40602829 17.403431,3 17.9558756,3 C18.5083201,3 18.9563024,3.44733638 18.9563024,4.00046178 L18.9563024,16.5855338 L21.2484452,14.2934386 C21.6391742,13.902523 22.2729787,13.902523 22.6627033,14.2934386 C23.0534322,14.6833466 23.0534322,15.3160657 22.6627033,15.7069812 L18.664009,19.7058058 C18.5716001,19.7984971 18.4601068,19.8720457 18.3375645,19.9224214 C18.2150223,19.9738046 18.0854489,20 17.9548711,20 C17.6013066,20 17.3210665,19.8539104 17.1543287,19.6131145 L13.2490478,15.7069812 Z M2,7 C2,6.44771525 2.45408034,6 2.99877667,6 L12.9569733,6 C13.5085825,6 13.95575,6.44386482 13.95575,7 C13.95575,7.55228475 13.5016697,8 12.9569733,8 L2.99877667,8 C2.44716755,8 2,7.55613518 2,7 Z M2,11 C2,10.4477153 2.45053045,10 3.00760124,10 L8.94814876,10 C9.50463156,10 9.95575,10.4438648 9.95575,11 C9.95575,11.5522847 9.50521955,12 8.94814876,12 L3.00760124,12 C2.45111844,12 2,11.5561352 2,11 Z M2,15 C2,14.4477153 2.45377482,14 2.99820275,14 L4.95754725,14 C5.5088394,14 5.95575,14.4438648 5.95575,15 C5.95575,15.5522847 5.50197518,16 4.95754725,16 L2.99820275,16 C2.4469106,16 2,15.5561352 2,15 Z"
					/>
				</svg>
			)}
		</span>
	</div>
);

export default withStyles(styles)(SelectFieldItemSort);
